export enum AdvancedCleaningOption {
  All,
  Connector,
  RenderCache
}
